module.exports = __webpack_public_path__ + "img/top_layout.1606ed02.svg";